import { use } from 'react';

import {StudentEvaluationFormType} from "../../../types/formTypes"
import {FormField} from "../../../types/types"
import { PostUrl, GetUrl } from "../../../api/endpointConfig";
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { useParams, useNavigate } from "react-router-dom";
import { useLoader } from "../../../Loader/LoaderContext";
import { ToastService } from "../../../utils/toastService";
import { useGet } from "../../../services/hooks/useGet";

const useStudentEvaluationForm = () => {
  const { id } = useParams();
  const { showLoader, hideLoader } = useLoader();
  const navigate = useNavigate()
  const studentEvaluationDetail = JSON.parse(localStorage.getItem("StudentEvaluation") || "{}");
  const evaluatioid = studentEvaluationDetail.id
  const { data = [], isLoading, isError } = useGet<any>(`${GetUrl.getOngoingEvaluation}/${id}`,undefined, !!id);

  const { mutate } = useMutationByMethod<any>(
    "post",
    `${PostUrl.postEvaluation}/${Number(evaluatioid)}`
  );
  
const handleSubmit = (data: any) => {
   mutate(data, {
        onSuccess: (data: any) => {
          hideLoader()
          ToastService.success(`Evaluation has been submitted successfully.`);
          navigate(`/student-evaluation-view/${evaluatioid}`)
        },
        onError: (err: any) => {
          hideLoader()
          console.error("error", err);
          ToastService.error(err)
        }
      })
}

  const fundsFormFields: FormField<StudentEvaluationFormType>[] = [
  { name: 'evaluator_name',text_label: 'Evaluator Name' ,defaultValue: data.evaluator_name ?? '', label: 'Evaluator Name', type: 'text', required: true, grid: { xs: 12, sm: 6, md: 6, lg: 6 }},
  { name: 'interview_date',text_label: 'Evaluation Date',defaultValue: data.interview_date ?? '', label: 'Evaluation Date', type: 'date', required: true, grid: { xs: 12, sm: 6, md: 6, lg: 6 } },
  { name: 'evaluation_outcome',text_label: 'Evaluation Remarks',disabled: !!id ,defaultValue: data.evaluation_outcome ?? '', label: 'Evaluation Remarks', type: 'textArea', required: false, grid: { xs: 12, sm: 12, md: 12, lg: 12 } },
];
  return {studentEvaluationDetail, fundsFormFields, handleSubmit, isLoading, isError, id }
}

export default useStudentEvaluationForm